import { Box, HTMLChakraProps, Link } from "@chakra-ui/react";
import { DocumentType, gql } from "__generated__/gql";

const fragment = gql(/* GraphQL */ `
  fragment PhoneNumberLinkFields on PhoneNumber {
    phoneRFC3966: phoneFormatted(format: RFC3966)
    phoneNational: phoneFormatted(format: NATIONAL)
  }
`);

type Props = HTMLChakraProps<"span"> & {
  phoneNumber: Partial<DocumentType<typeof fragment>> | null | undefined;
};

export default function PhoneNumberLink({ phoneNumber, ...rest }: Props) {
  if (!phoneNumber) return null;

  const { phoneRFC3966, phoneNational } = phoneNumber;

  if (!phoneNational) return null;

  if (!phoneRFC3966)
    return (
      <Box as="span" {...rest}>
        {phoneNational}
      </Box>
    );

  return (
    <Link href={phoneRFC3966} {...rest}>
      {phoneNational}
    </Link>
  );
}
